import { createRouter, createWebHistory } from 'vue-router'
import administracao from './administracao.js'

export const routes = [
  ...administracao,
  {
    path: '/clientes',
    name: 'client',
    component: () => import('@/views/clientes/Cliente.vue'),
    meta: { breadcrumb: [{ title: 'Clientes' }] },
  },
  {
    path: '/clientes/novo',
    name: 'clientNew',
    component: () => import('@/views/clientes/ClienteNew.vue'),
    meta: { breadcrumb: [{ title: 'Clientes', name: 'client' }, { title: 'Novo' }] },
  },
  {
    path: '/clientes/:id/editar',
    name: 'clientUpdate',
    component: () => import('@/views/clientes/ClienteNew.vue'),
    meta: { breadcrumb: [{ title: 'Clientes', name: 'client' }, { title: 'Editar' }] },
  },
  {
    path: '/projetos',
    name: 'project',
    component: () => import('@/views/projetos/Projeto.vue'),
    meta: { breadcrumb: [{ title: 'Projetos' }] },
  },
  {
    path: '/projetos/novo',
    name: 'projectNew',
    component: () => import('@/views/projetos/ProjetoNew.vue'),
    meta: { breadcrumb: [{ title: 'Projetos', name: 'project' }, { title: 'Novo' }] },
  },
  {
    path: '/projetos/:id',
    name: 'projectOverview',
    component: () => import('@/views/projetos/ProjetoOverview.vue'),
    meta: { breadcrumb: [{ title: 'Projetos', name: 'project' }, { title: 'Overview' }] },
  },
  {
    path: '/projetos/:id/editar',
    name: 'projectUpdate',
    component: () => import('@/views/projetos/ProjetoNew.vue'),
    meta: { breadcrumb: [{ title: 'Projetos', name: 'project' }, { title: 'Editar' }] },
  },
  {
    path: '/entregas', name: 'delivery', component: () => import('@/views/entregas/Entrega.vue'), meta: { breadcrumb: [{ title: 'Entregas' }] },
  },
  {
    path: '/entregas/novo', name: 'deliveryNew', component: () => import('@/views/entregas/EntregaNew.vue'), meta: { breadcrumb: [{ title: 'Entregas', name: 'delivery' }, { title: 'Novo' }] },
  },
  {
    path: '/entregas/:id/editar', name: 'deliveryUpdate', component: () => import('@/views/entregas/EntregaNew.vue'), meta: { breadcrumb: [{ title: 'Entregas', name: 'delivery' }, { title: 'Editar' }] },
  },
  { path: '/solicitacoes', name: 'request', component: () => import('@/views/solicitacoes/Solicitacao.vue') },
  { path: '/solicitacoes/nova', name: 'requestNew', component: () => import('@/views/solicitacoes/SolicitacaoNew.vue') },
  { path: '/solicitacoes/:id/editar', name: 'requestUpdate', component: () => import('@/views/solicitacoes/SolicitacaoNew.vue') },
  { path: '/ausencias', name: 'absence', component: () => import('@/views/ausencias/Ausencia.vue'), meta: { breadcrumb: [{ title: 'Ausências' }] } },
  { path: '/ausencias/nova', name: 'absenceNew', component: () => import('@/views/ausencias/AusenciaNew.vue'), meta: { breadcrumb: [{ title: 'Ausências', name: 'absence' }, { title: 'Nova' }] } },
  { path: '/ausencias/:id/editar', name: 'absenceUpdate', component: () => import('@/views/ausencias/AusenciaNew.vue'), meta: { breadcrumb: [{ title: 'Ausências', name: 'absence' }, { title: 'Editar' }] } },
  { path: '/bloqueios', name: 'blocker', component: () => import('@/views/bloqueios/Bloqueio.vue'), meta: { breadcrumb: [{ title: 'Bloqueios' }] } },
  { path: '/bloqueios/novo', name: 'blockerNew', component: () => import('@/views/bloqueios/BloqueioNew.vue'), meta: { breadcrumb: [{ title: 'Bloqueios', name: 'blocker' }, { title: 'Novo' }] } },
  { path: '/bloqueios/:id/editar', name: 'blockerUpdate', component: () => import('@/views/bloqueios/BloqueioNew.vue'), meta: { breadcrumb: [{ title: 'Bloqueios', name: 'blocker' }, { title: 'Editar' }] } },
  { path: '/equipe', name: 'team', component: () => import('@/views/equipe/Equipe.vue'), meta: { breadcrumb: [{ title: 'Equipe' }] } },
  { path: '/dailys', name: 'daily', component: () => import('@/views/dailys/Daily.vue'), meta: { breadcrumb: [{ title: 'Dailys' }] } },
  { path: '/painel-projeto/:id?', name: 'projectPanel', component: () => import('@/views/projetos/ProjetoOverview.vue'), meta: { breadcrumb: [{ title: 'Painel do Projeto' }] } },
  { path: '/calendario', name: 'calendar', component: () => import('@/views/calendario/Calendario.vue'), meta: { breadcrumb: [{ title: 'Calendário' }] } },
  { path: '/timeline', name: 'timeline', component: () => import('@/views/timeline/Timeline.vue'), meta: { breadcrumb: [{ title: 'Timeline' }] } },
  { path: '/timeline/novo', name: 'timelineNew', component: () => import('@/views/timeline/TimelineNew.vue'), meta: { breadcrumb: [{ title: 'Timeline', name: 'timeline' }, { title: 'Novo evento' }] } },
  { path: '/atencoes', name: 'attention', component: () => import('@/views/atencoes/Atencoes.vue'), meta: { breadcrumb: [{ title: 'Atenções' }] } },
  { path: '/notas', name: 'note', component: () => import('@/views/notas/Nota.vue'), meta: { breadcrumb: [{ title: 'Notas' }] } },
  { path: '/notas/nova', name: 'noteNew', component: () => import('@/views/notas/NotaNew.vue'), meta: { breadcrumb: [{ title: 'Notas', name: 'note' }, { title: 'Nova' }] } },
  { path: '/notas/:id/editar', name: 'noteUpdate', component: () => import('@/views/notas/NotaNew.vue'), meta: { breadcrumb: [{ title: 'Notas', name: 'note' }, { title: 'Editar' }] } },
  { path: '/decisoes', name: 'decision', component: () => import('@/views/decisoes/Decisao.vue'), meta: { breadcrumb: [{ title: 'Decisões' }] } },
  { path: '/decisoes/nova', name: 'decisionNew', component: () => import('@/views/decisoes/DecisaoNew.vue'), meta: { breadcrumb: [{ title: 'Decisões', name: 'decision' }, { title: 'Nova' }] } },
  { path: '/decisoes/:id/editar', name: 'decisionUpdate', component: () => import('@/views/decisoes/DecisaoNew.vue'), meta: { breadcrumb: [{ title: 'Decisões', name: 'decision' }, { title: 'Editar' }] } },
  { path: '/reunioes', name: 'meeting', component: () => import('@/views/reunioes/Reuniao.vue'), meta: { breadcrumb: [{ title: 'Reuniões' }] } },
  { path: '/reunioes/nova', name: 'meetingNew', component: () => import('@/views/reunioes/ReuniaoNew.vue'), meta: { breadcrumb: [{ title: 'Reuniões', name: 'meeting' }, { title: 'Nova' }] } },
  { path: '/reunioes/:id/editar', name: 'meetingUpdate', component: () => import('@/views/reunioes/ReuniaoNew.vue'), meta: { breadcrumb: [{ title: 'Reuniões', name: 'meeting' }, { title: 'Editar' }] } },
  { path: '/ambientes', name: 'environment', component: () => import('@/views/ambientes/Ambiente.vue'), meta: { breadcrumb: [{ title: 'Ambientes' }] } },
  { path: '/ambientes/novo', name: 'environmentNew', component: () => import('@/views/ambientes/AmbienteNew.vue'), meta: { breadcrumb: [{ title: 'Ambientes', name: 'environment' }, { title: 'Novo' }] } },
  { path: '/ambientes/:id/editar', name: 'environmentUpdate', component: () => import('@/views/ambientes/AmbienteNew.vue'), meta: { breadcrumb: [{ title: 'Ambientes', name: 'environment' }, { title: 'Editar' }] } },
  { path: '/workspace', name: 'workspace', component: () => import('@/views/workspace/Workspace.vue'), meta: { breadcrumb: [{ title: 'Workspace' }] } },
  { path: '/workspace/novo', name: 'workspaceNew', component: () => import('@/views/workspace/WorkspaceNew.vue'), meta: { breadcrumb: [{ title: 'Workspace', name: 'workspace' }, { title: 'Novo' }] } },
  { path: '/workspace/:id/editar', name: 'workspaceUpdate', component: () => import('@/views/workspace/WorkspaceNew.vue'), meta: { breadcrumb: [{ title: 'Workspace', name: 'workspace' }, { title: 'Editar' }] } },
  { path: '/jira', name: 'jira', component: () => import('@/views/jira/Jira.vue'), meta: { breadcrumb: [{ title: 'Jira' }] } },
  {
    path: '/login',
    name: 'login',
    component: () => import('@/views/Login.vue'),
  },
  {
    path: '/home',
    name: 'home',
    component: () => import('@/views/Home.vue'),
  },
  {
    path: '/',
    name: 'base',
    component: () => import('@/views/Home.vue'),
  },
  {
    path: '/meu_perfil',
    name: 'myProfile',
    component: () => import('@/views/Perfil.vue'),
    meta: { breadcrumb: [{ title: 'Meu Perfil' }] },
  },
  {
    path: '/acesso-restrito',
    name: 'acessoRestrito',
    component: () => import('@/views/AcessoRestrito.vue'),
  },
]

const normalizePath = (path) => {
  const raw = String(path || '').toLowerCase().trim()
  if (!raw) return '/'

  const onlyPath = raw.split('?')[0].split('#')[0]
  const normalized = onlyPath.replace(/^\/+/g, '').replace(/\/+$/g, '')
  return normalized ? `/${normalized}` : '/'
}

const routeTemplateToRegex = (routeTemplate) => {
  const normalizedTemplate = normalizePath(routeTemplate)
  const escaped = normalizedTemplate.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')
  const withParams = escaped.replace(/:([a-zA-Z0-9_]+)/g, '[^/]+')
  return new RegExp(`^${withParams}$`, 'i')
}

const matchesRoute = (path, routeTemplate) => {
  if (!routeTemplate) {
    return false
  }
  const regex = routeTemplateToRegex(routeTemplate)
  return regex.test(path)
}

const getStoredUser = () => {
  const rawUser = localStorage.getItem('user')
  if (!rawUser || rawUser === 'undefined' || rawUser === 'null') {
    return null
  }

  try {
    return JSON.parse(rawUser)
  } catch (error) {
    return null
  }
}

const canAccessRoute = (toPath, user) => {
  const alwaysAllowed = new Set(['/home', '/', '/meu_perfil', '/acesso-restrito'])
  const path = normalizePath(toPath)

  if (alwaysAllowed.has(path)) {
    return true
  }

  const permissions = user?.permissions?.byScreenRoute || {}
  const entries = Object.entries(permissions)
  if (!entries.length) {
    return false
  }

  const permissionPaths = path === '/painel-projeto' || path.startsWith('/painel-projeto/')
    ? [path, '/projetos']
    : [path]

  return entries.some(([screenRoute, permission]) => {
    if (!permission?.get) {
      return false
    }

    return permissionPaths.some((permissionPath) => matchesRoute(permissionPath, screenRoute))
  })
}

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
})

router.beforeEach((to) => {
  const targetPath = normalizePath(to.path)
  const user = getStoredUser()

  if (targetPath === '/login') {
    return true
  }

  if (!user?.id) {
    return { path: '/login' }
  }

  if (!canAccessRoute(to.path, user)) {
    return { path: '/acesso-restrito' }
  }

  return true
})

export default router
